import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Flex,
  VStack,
  Link,
  Text,
  useToast,
  HStack,
} from "@chakra-ui/react";
import logo from "../../Assets/logo.png";
import logo1 from "../../Assets/logo1.png";
import bg from "../../Assets/InitBg.png";
import { COLORS } from "../../Helper/Colors";
import DotSpinner from "../../Components/Common/DotSpinner";
import { Form } from "./Login.style";
import { useLocation, useNavigate } from "react-router-dom";
import { YEAR } from "../../Helper/Constants";
import Api from "../../Helper/ApiHandler";
import { BackButton, FormInput } from "../../Components/Common/UI";
import { Cookies } from "react-cookie";

const ForgotPassword = () => {
  const api = new Api();
  const cookies = new Cookies();
  let location = useLocation();
  let navigate = useNavigate();
  let toast = useToast();
  const [btnLoading, setBtnLoading] = useState(false);
  let to = location.state?.from || "/dashboard";

  useEffect(() => {
    if (cookies.get("jomtoken")) {
      navigate(to, { replace: true });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to]);

  const initialValues = {
    email: "",
  };
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter valid email!")
      .required("Email is required!"),
  });
  const handleFormSubmit = async (values) => {
    try {
      setBtnLoading(true);
      const { message } = await api.post("auth/forgot-password", values);
      setBtnLoading(false);
      toast({
        description: message,
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top",
      });
      navigate("/", { replace: true });
    } catch (error) {
      setBtnLoading(false);
      toast({
        description: error.message,
        status: "error",
        duration: 2000,
        isClosable: false,
        position: "top",
      });
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: handleFormSubmit,
  });

  const handleChange = (name, value) => {
    formik.setFieldTouched(name, true, true);
    formik.setValues({ ...formik.values, [name]: value });
  };

  const { values, touched, errors } = formik;
  return (
    <>
      <Flex
        alignItems={{ md: "center" }}
        position="relative"
        h="100vh"
        direction={{ sm: "column", md: "row" }}
      >
        <Text
          position={"absolute"}
          bottom={10}
          left={{ sm: "0", md: "-28%" }}
          fontSize="sm"
          color={{ sm: "brand.900", md: "brand.100" }}
          width={"100%"}
          textAlign={"center"}
        >
          &copy; {YEAR}{" "}
          <Link color="brand.500" href="https://staging.just-one-moment.com/">
            justonemoment.com
          </Link>{" "}
          All Rights Reserved.
        </Text>
        <Box
          flex={{ sm: "0.15", md: "0.8" }}
          height={{ md: "100%" }}
          display={"flex"}
          alignItems={{ sm: "center", md: "center" }}
          justifyContent={"center"}
          backgroundImage={{ md: `url(${bg})` }}
          backgroundSize={"cover"}
          backgroundRepeat={"no-repeat"}
          backgroundColor={COLORS.brandDark}
        >
          <Box>
            <img src={logo} alt="logo" />
          </Box>
          <Box marginLeft={"20px"}>
            <img src={logo1} alt="logo" />
          </Box>
        </Box>
        <Box position={"relative"} flex={{ sm: "0.65", md: "1" }}>
          <Box
            display={"flex"}
            width={"100%"}
            height={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Form onSubmit={formik.handleSubmit}>
              <VStack spacing={6} align="flex-start">
                <HStack alignItems={"center"} spacing={4}>
                  <BackButton
                    size={22}
                    color={COLORS.brand}
                    bgColor={"transparent"}
                    _hover={{}}
                    _focus={{}}
                    _active={{}}
                    onClick={() => navigate("/")}
                  />
                  <Text fontSize={"2xl"} fontWeight={"bold"} textAlign="start">
                    Forgot Password
                  </Text>
                </HStack>
                <Text fontSize={"1xl"} textAlign="start">
                  Enter the email address associated with your account And we’ll
                  send you a link to reset your password.
                </Text>
                <FormInput
                  onBlur={formik.handleBlur}
                  type="email"
                  name="email"
                  label="Email"
                  placeholder="Enter your email"
                  value={values.email}
                  error={!!touched.email && errors.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  errorMsg={errors.email}
                  isRequired={true}
                />
                <Button
                  isLoading={btnLoading}
                  spinner={<DotSpinner key={"login"} color={"#fff"} size={8} />}
                  type="submit"
                  colorScheme="brand"
                  className="custom-btn"
                  size={"lg"}
                  isFullWidth
                >
                  Send link
                </Button>
              </VStack>
            </Form>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default ForgotPassword;
